exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".managers-list {\n  width: 100%;\n}\n.managers-page {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Managers/containers/Managers.less
// module id = 1209
// module chunks = 0